export const handleChangeDataModalEditMobileWarning = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_EDIT_MOBILE_WARNING', name, value
});